import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { connect } from 'react-redux';
import SaveLogsForAmazonProductListingService from "../../../../../Service/OPSServices/AmazonProductListing/SaveLogsForAmazonProductListingService";

function ProductListingReview(props) {
  const { listingData } = props;

  const oldData = (listingData && listingData.catalogData) || {};
  const form = (listingData && listingData.formData) || {};
  const pricing = (listingData && listingData.pricing) || {};
  const currency = (listingData && listingData.currency) || form.currency || "";
  const variants = (listingData && listingData.variants) || [];

  const mainImage = form.mainImage || "";
  const galleryImages = form.galleryImages || [];
  const [isOldDescExpanded, setIsOldDescExpanded] = useState(false);
  const [isNewDescExpanded, setIsNewDescExpanded] = useState(false);

  // useEffect(()=>{
  //   console.log(" FIN", listingData.asin);
  // console.log(" FINAL Old Values", oldData);
  // console.log("FINAL New Values", {
  //   ...form,
  //   pricing,
  //   currency,
  //   variants
  // });
  // })

  const oldDesc = oldData.description || "N/A";
  const newDesc = form.description || "-";
  const descLimit = 150;
  const showOldToggle = oldDesc.length > descLimit;
  const showNewToggle = newDesc.length > descLimit;

  let oldVariantsCount = "N/A";
  if (oldData.variants && oldData.variants.length > 0) {
    oldVariantsCount = oldData.variants.length;
  } else if (oldData.sku) {
    oldVariantsCount = String(oldData.sku).split(",").map(s => s.trim()).length;
  }

  const hasChanged = (oldVal, newVal) => {
    const o = oldVal === null || oldVal === undefined ? "" : String(oldVal).trim();
    const n = newVal === null || newVal === undefined ? "" : String(newVal).trim();
    return n !== "" && n !== "-" && o !== n;
  };

 
  
  const getUpdatedValues = (oldData, form) => {
    console.log("Old Data:", oldData);
    console.log("Form Data:", form);
  
    const updatedValues = [];

    // Loop through the keys of the form object
    for (const key in form) {
      // If the old value is different from the new value (checking strings/arrays/objects)
      if (JSON.stringify(oldData[key]) !== JSON.stringify(form[key])) {
        
        // Create a log entry for the updated field
        updatedValues.push({
          asin:listingData.asin,
          filedName: key,                   // Field name (e.g. 'fulfillment', 'galleryImages', etc.)
          filedValue: form[key],            // New value of the field (e.g. "FBA", image URL, etc.)
          oldValue: oldData[key] || "N/A",  // Old value of the field or "N/A" if it's missing
          newValue: form[key]               // New value
        });
      }
    }

    console.log(updatedValues);
    SaveLogsForAmazonProductListingService(props.token,updatedValues).then((res)=>{
      if(res){
        console.log(res)
      }
    })
   

    return updatedValues;
};

  return (
    <Container>
      <Row>
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 9 : Review Listing</h4>
        </Col>

        <Col md={12}>
          <Card className="p-4">
            
            <Row className="mb-4 text-center pb-2" style={{ borderBottom: "2px solid #eee" }}>
              <Col md={2}></Col>
              <Col md={4} className="text-left">
                <span className="text-muted"><b>Old Value</b></span>
              </Col>
              <Col md={6} className="text-left">
                <span className="text-muted"><b>New Value</b></span>
              </Col>
            </Row>

            <h5 className="mt-2"><b>Product Information</b></h5>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Product Title :</Col>
              <Col md={4}>{oldData.productTitle || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.productTitle, form.productTitle) ? "ans-background" : ""}>
                  {form.productTitle || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Brand :</Col>
              <Col md={4}>{oldData.brand || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.brand, form.brand) ? "ans-background" : ""}>
                  {form.brand || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">SKU :</Col>
              <Col md={4}>{oldData.sku || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.sku, form.sku) ? "ans-background" : ""}>
                  {form.sku || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Category :</Col>
              <Col md={4}>{oldData.category || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.category, form.category) ? "ans-background" : ""}>
                  {form.category || "-"}
                </div>
              </Col>
            </Row>

            <hr />

            {/* PRICING */}
            <h5><b>Pricing</b></h5>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Currency :</Col>
              <Col md={4}>{oldData.currency || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.currency, currency) ? "ans-background" : ""}>
                  {currency || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Sale Price :</Col>
              <Col md={4}>{oldData.salePrice ? oldData.salePrice : "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.salePrice, pricing.salePrice || form.salePrice) ? "ans-background" : ""}>
                  {pricing.salePrice || form.salePrice || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">MRP :</Col>
              <Col md={4}>{oldData.price || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.price, pricing.mrp || form.mrp) ? "ans-background" : ""}>
                  {pricing.mrp || form.mrp || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Min Price :</Col>
              <Col md={4}>{oldData.minPrice || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.minPrice, pricing.minPrice || form.minPrice) ? "ans-background" : ""}>
                  {pricing.minPrice || form.minPrice || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Max Price :</Col>
              <Col md={4}>{oldData.maxPrice || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.maxPrice, pricing.maxPrice || form.maxPrice) ? "ans-background" : ""}>
                  {pricing.maxPrice || form.maxPrice || "-"}
                </div>
              </Col>
            </Row>

            <hr />

            {/* INVENTORY */}
            <h5><b>Inventory</b></h5>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Fulfillment :</Col>
              <Col md={4}>{oldData.fulfillment || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.fulfillment, form.fulfillment) ? "ans-background" : ""}>
                  {form.fulfillment || "-"}
                </div>
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Quantity :</Col>
              <Col md={4}>{oldData.quantity || "N/A"}</Col>
              <Col md={6}>
                <div className={hasChanged(oldData.quantity, form.fulfillment === "FBM" ? form.quantity : "Managed by Amazon (FBA)") ? "ans-background" : ""}>
                  {form.fulfillment === "FBM" ? (form.quantity || "-") : "Managed by Amazon (FBA)"}
                </div>
              </Col>
            </Row>

            <hr />

            {/* CONTENT */}
            <h5><b>Content</b></h5>

            <Row className="mb-2">
              <Col md={2} className="amazon-listing-labels">Bullets :</Col>
              <Col md={4}>
                {(oldData.bullets || []).length > 0
                  ? oldData.bullets.map((b, i) => <div key={i}>• {b}</div>)
                  : "N/A"}
              </Col>
              <Col md={6}>
                {(form.bullets || []).length > 0
                  ? form.bullets.map((b, i) => {
                      const oldBullet = (oldData.bullets && oldData.bullets[i]) ? oldData.bullets[i] : "";
                      const isBulletChanged = hasChanged(oldBullet, b);
                      return (
                        <div key={i} className={isBulletChanged ? "ans-background mb-1" : "mb-1"}>
                          • {b}
                        </div>
                      );
                    })
                  : "-"}
              </Col>
            </Row>

            <Row className="mb-2">
              <Col md={2} className="amazon-listing-labels">Description :</Col>
              
              <Col md={4} style={{ whiteSpace: "pre-wrap" }}>
                {showOldToggle && !isOldDescExpanded 
                  ? `${oldDesc.substring(0, descLimit)}...` 
                  : oldDesc}
                {showOldToggle && (
                  <span 
                    style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px', fontWeight: 'bold' }} 
                    onClick={() => setIsOldDescExpanded(!isOldDescExpanded)}
                  >
                    {isOldDescExpanded ? "Read Less" : "Read More"}
                  </span>
                )}
              </Col>

              <Col md={6} style={{ whiteSpace: "pre-wrap" }}>
                <div className={hasChanged(oldDesc, newDesc) ? "ans-background" : ""}>
                  {showNewToggle && !isNewDescExpanded 
                    ? `${newDesc.substring(0, descLimit)}...` 
                    : newDesc}
                  {showNewToggle && (
                    <span 
                      style={{ color: '#007bff', cursor: 'pointer', marginLeft: '5px', fontWeight: 'bold' }} 
                      onClick={() => setIsNewDescExpanded(!isNewDescExpanded)}
                    >
                      {isNewDescExpanded ? "Read Less" : "Read More"}
                    </span>
                  )}
                </div>
              </Col>
            </Row>

            <hr />

            {/* IMAGES */}
            <h5><b>Images</b></h5>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Main Image :</Col>
              <Col md={4}>
                {oldData.main_image ? (
                  <img src={oldData.main_image} alt="old main" width="120" />
                ) : "N/A"}
              </Col>
              <Col md={6}>
                {mainImage ? (
                  <img src={mainImage} alt="new main" width="120" />
                ) : "-"}
              </Col>
            </Row>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Gallery Images :</Col>
              <Col md={4}>
                {(oldData.gallery_images || []).length > 0 ? (
                  oldData.gallery_images.map((img, i) => (
                    <img key={`old-gal-${i}`} src={img} width="80" style={{ marginRight: "5px", marginBottom: "5px" }} alt="old gallery" />
                  ))
                ) : "N/A"}
              </Col>
              <Col md={6}>
                {galleryImages.length > 0 ? (
                  galleryImages.map((img, i) => {
                    const isNewOrChangedImage = !(oldData.gallery_images || []).includes(img);
                    
                    return (
                      <img 
                        key={`new-gal-${i}`} 
                        src={img} 
                        width="80" 
                        style={{ marginRight: "5px", marginBottom: "5px" }} 
                        alt="new gallery" 
                        className={isNewOrChangedImage ? "changed-image-highlight" : ""}
                      />
                    );
                  })
                ) : "-"}
              </Col>
            </Row>

            <hr />

            {/* VARIANTS */}
            <h5><b>Variations</b></h5>

            <Row className="mb-2 align-items-center">
              <Col md={2} className="amazon-listing-labels">Total Variants :</Col>
              <Col md={4}>{oldVariantsCount}</Col>
              <Col md={6}>
                <div className={hasChanged(oldVariantsCount, variants.length) ? "ans-background" : ""}>
                  {variants.length}
                </div>
              </Col>
            </Row>

          </Card>
        </Col>

        {/* Buttons */}
        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>

          <div>
            <button className="btn btn-secondary mr-2">
              Save Draft
            </button>

            <button
              className="btn btn-success"
              onClick={()=>{props.nextStep();getUpdatedValues(oldData, form)}}
            >
              Publish to Amazon
            </button>
          </div>
        </Col>

      </Row>
    </Container>
  );
}
const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
  }
}

export default connect(mapStateToProps)(ProductListingReview);